import { type DriveFile } from '@/shared/DriveTypes';
import { ArrowDropDown } from '@mui/icons-material';
import { bindTrigger, type PopupState } from 'material-ui-popup-state/hooks';
import { darken } from 'polished';
import { fadeInSlide, fadeInSlideRight } from '~/app.css';
import * as buttonStyles from '~/elements/Buttons/Button.css';
import { useOpenId } from '~/utils/store';
import { cx } from '~/utils/utils';

export const AddNewButton = ({
  wiki,
  file,
  popupState,
  animation,
}: {
  wiki: DriveFile | undefined;
  file: DriveFile;
  popupState: PopupState;
  animation?: 'left' | 'right' | 'none';
}) => {
  const { setOpenId } = useOpenId();
  const color = wiki?.properties?.fontColor;
  const backgroundColor = wiki?.properties?.color;
  const custom = Boolean(color || backgroundColor);

  return (
    <button
      {...bindTrigger(popupState)}
      onClick={(e) => {
        popupState.open(e);
        setOpenId(file.id);
      }}
      type="button"
      className={cx({
        [buttonStyles.addNew]: true,
        [buttonStyles.custom]: custom,
        [fadeInSlideRight]: animation === 'right',
        [fadeInSlide]: animation === 'left',
      })}
      style={{
        ...(custom && {
          color,
          '--button-bg-color': backgroundColor,
          '--button-bg-color-hover': backgroundColor ? darken(0.1, backgroundColor) : undefined,
        }),
      }}
    >
      Add new
      <ArrowDropDown className={buttonStyles.arrowDown} />
    </button>
  );
};
